import { DefaultOptions, QueryClient } from '@tanstack/react-query';

const FIVE_MINUTES = 5 * 60 * 1000;
const THIRTY_MINUTES = 30 * 60 * 1000;

// Shared cache for Firestore reads. Data is served from memory for 5 minutes,
// after which it is shown instantly and refreshed in the background.
export const queryClientDefaultOptions: DefaultOptions = {
    queries: {
        staleTime: FIVE_MINUTES,
        gcTime: THIRTY_MINUTES,
        refetchOnWindowFocus: false,
        retry: 1,
    },
};

export const queryClient = new QueryClient({ defaultOptions: queryClientDefaultOptions });
